
export default function onboard( state = [], action = {} ){

	switch( action.type ){
		case 'CANDIDATE_INVITE':
			return action.onboard
		case 'CANDIDATE_GET_COMPANY':
			return action.onboard
		case 'CANDIDATE_GET_DEPARTMENT':
			return action.onboard
		case 'GET_CANDIDATE':
			return action.onboard
		case 'SET_CANDIDATE_CONVERT':
			return action.onboard
		case 'ON_UPLOADED_PROFILE_PIC':
			return action.onboard
		case 'SAVE_ONBOARD':
			return action.onboard
		case 'REQUEST_CHECK_LIST':
			return action.onboard
		case 'CANDIDATE_UPDATE_CHECK_VALUE':
			return action.onboard
		default: return state;
	}
		
}


// WEBPACK FOOTER //
// ./src/store/reducers/onboarding/onboard.reducer.js